import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { topicCollectionHeaderCollection$key } from "scmp-app/queries/__generated__/topicCollectionHeaderCollection.graphql";
import type { topicCollectionHeaderRelatedLinksConnection$key } from "scmp-app/queries/__generated__/topicCollectionHeaderRelatedLinksConnection.graphql";

import {
  Container,
  Content,
  Label,
  LabelContainer,
  StyledTopicCollectionHeaderRelatedLinks,
  Title,
  TitleContainer,
  TopicContainer,
  Wrapper,
} from "./styles";

type Props = {
  className?: string;
  topicCollectionHeaderRelatedLinksConnectionReference: topicCollectionHeaderRelatedLinksConnection$key;
  topicCollectionReference: topicCollectionHeaderCollection$key;
};

export const TopicCollectionHeader: FunctionComponent<Props> = ({
  className,
  topicCollectionHeaderRelatedLinksConnectionReference,
  topicCollectionReference,
}) => {
  const topicCollection = useFragment(
    graphql`
      fragment topicCollectionHeaderCollection on Collection {
        name
      }
    `,
    topicCollectionReference,
  );

  return (
    <Container className={className}>
      <Wrapper>
        <Content>
          <LabelContainer>
            <Label>TOPIC COLLECTION</Label>
          </LabelContainer>

          <TopicContainer>
            <TitleContainer>
              <Title>{topicCollection.name}</Title>
            </TitleContainer>
          </TopicContainer>
        </Content>
      </Wrapper>
      <StyledTopicCollectionHeaderRelatedLinks
        label="Included topics:"
        reference={topicCollectionHeaderRelatedLinksConnectionReference}
      />
    </Container>
  );
};

TopicCollectionHeader.displayName = "TopicCollectionHeader";
